import styles from './ccf-book-outline-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfBookOutlineIconProps extends SvgIconProps {}
/**
 * 
 * @param props -
 * @example
 * @returns 
 */
export function CcfBookOutlineIcon(props: CcfBookOutlineIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M14.9997 1.6665C15.4417 1.6665 15.8656 1.8421 16.1782 2.15466C16.4907 2.46722 16.6663 2.89114 16.6663 3.33317V16.6665C16.6663 17.1085 16.4907 17.5325 16.1782 17.845C15.8656 18.1576 15.4417 18.3332 14.9997 18.3332H4.99967C4.55765 18.3332 4.13372 18.1576 3.82116 17.845C3.5086 17.5325 3.33301 17.1085 3.33301 16.6665V3.33317C3.33301 2.89114 3.5086 2.46722 3.82116 2.15466C4.13372 1.8421 4.55765 1.6665 4.99967 1.6665H14.9997ZM14.9997 3.33317H10.833V9.99984L8.74967 8.12484L6.66634 9.99984V3.33317H4.99967V16.6665H14.9997V3.33317Z" fill="#007AB8"/>
    </SvgIcon>
  );
}

export default CcfBookOutlineIcon;
